import { Component, OnInit } from '@angular/core';
import { FlashCoupon } from "../../../models/inModels/flashcoupon";
import { LazyLoadEvent } from "../../../models/DataTables/lazyLoadEvent";
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { Router } from '@angular/router';
import { DataTable } from 'primeng/primeng';
import { FlashCouponService } from "../../../services/flash/flash-coupon-service";

@Component({
	selector: 'app-flash-coupons',
	templateUrl: './flash-coupons.component.html',
	styleUrls: ['./flash-coupons.component.css']
})
export class FlashCouponsComponent {
	items: FlashCoupon[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];

	constructor(
		private service: FlashCouponService,
		private router: Router,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: any) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(item: FlashCoupon) {
		this.router.navigate(['flash-coupon/edit', item.Code]);
	}

	delete(item: FlashCoupon) {
		this.confirmationService.confirm({
			message: `Are you sure you want to delete this Coupon?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(item.Code).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/flash/flash-coupons/flash-coupons.component.ts